export default {
  getAccessToken: state => state.access_token,
  getUser: state => state.user,
  getUsers: state => state.users,
}
